import { useOnlineStatus } from 'Hook/General/useOnlineStatus';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAppStatus } from '../services/checkConnection';

const useWindowClick = (setIsLoading) => {
	const dispatch = useDispatch();
	const {
		pathname,
		// search
	} = useLocation();
	const onlineStatus = useOnlineStatus();

	const resultProps = useSelector((state) => ({
		token: state.login?.token,
		currentVersion: state.login?.releseNoteState?.Version,
	}));

	const navigate = useNavigate();
	function disableBackButton() {
		if (pathname !== '/auth/login') {
			window.location.replace('/auth/login');
		}
	}

	useEffect(() => {
		if (['/auth/login'].includes(pathname)) {
			disableBackButton();
			window.addEventListener('popstate', disableBackButton);
		}

		return () => {
			window.removeEventListener('popstate', disableBackButton);
		};
	}, [pathname]);

	const onClickMethod = useCallback(async () => {
		await getAppStatus()
			.then((res) => {
				const response = res?.data;

				if (response?.app?.logout || response?.app?.refresh) {
					response?.app?.logout && localStorage.clear();
					response?.app?.logout && navigate('/auth/login');

					window.location.reload();
				} else {
					dispatch({
						type: 'connection/updateWebStatus',
						payload: response,
					});
				}

				setIsLoading?.(false);
			})
			.catch(() => {
				setIsLoading?.(false);
			});
	}, [dispatch, resultProps?.token]);

	useEffect(() => {
		if (onlineStatus) {
			onClickMethod();
			window.addEventListener('click', onClickMethod);
		} else {
			setIsLoading(false);
		}
	}, [onlineStatus]);

	return null;
};

export default useWindowClick;
